export const ConfigurationConstant = {
  CONFIGURATION_TABLE_SAGA: "CONFIGURATION_TABLE_SAGA",
  CONFIGURATION_TABLE_REQUEST: "CONFIGURATION_TABLE_REQUEST",
  CONFIGURATION_TABLE_RESPONSE: "CONFIGURATION_TABLE_RESPONSE",
  CONFIGURATION_TABLE_API: "/global/configuration",

  CONFIGURATION_UPDATE_CANCEL_SAGA: "CONFIGURATION_UPDATE_CANCEL_SAGA",
  CONFIGURATION_UPDATE_CANCEL_REQUEST: "CONFIGURATION_UPDATE_CANCEL_REQUEST",
  CONFIGURATION_UPDATE_CANCEL_RESPONSE: "CONFIGURATION_UPDATE_CANCEL_RESPONSE",
  CONFIGURATION_UPDATE_CANCEL_API: "/global/configuration",
};
